// extracted by mini-css-extract-plugin
module.exports = {"loadOverlay":"loader_loadOverlay__39qY9","spin":"loader_spin__3BbVb","loadContainer":"loader_loadContainer__2bTa8","loaderSpinner":"loader_loaderSpinner__2Tc6t"};